import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyDatepickerComponent } from './datepicker.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot()
    ],
    declarations: [MyDatepickerComponent],
    exports: [MyDatepickerComponent],
    providers: []
})

export class MyDatepickerModule { }
